/* Stop the family tiles changing colour while you scroll on a phone.

   WHAT WAS HAPPENING
   The grid reshuffles tile colours so no two tiles in a row share one, and
   it redoes that on window resize — sensible on a desktop, where a resize
   means the row width really changed.

   On a phone it is not sensible at all. Scrolling collapses and expands the
   browser's address bar, and every one of those fires a resize event. So
   the colours reshuffled continuously as the page moved under the finger.
   Measured here: one resize repainted 6 of 155 tiles, five resizes repainted
   36. Nothing was broken; it just never sat still.

   THE FIX
   A colour is chosen once per family and then held. The first time a tile
   is painted its colour is recorded on the element, and any later attempt to
   change it is put back. Tiles the merchant has fixed with a border colour
   were already exempt and stay exempt.

   WHY NOT JUST IGNORE RESIZE EVENTS
   Because a real resize — rotating the phone, or a desktop window actually
   being dragged — should still be free to relayout. This does not block the
   shuffler from running; it only stops the OUTCOME changing, which is the
   part that was annoying. A rotation gets the same colours in a new layout,
   which is what a shopper expects: the tile they were looking at is still
   the same colour.
*/
(function(){
"use strict";

var LOCKED = 'data-tintlock';

function lockAll(root){
  var tiles = (root || document).querySelectorAll('.card .sh');
  for(var i=0;i<tiles.length;i++){
    var el = tiles[i];
    if(el.getAttribute(LOCKED)) continue;
    var bg = el.style.background || el.style.backgroundColor;
    if(bg) el.setAttribute(LOCKED, bg);
  }
}

/* Put back any colour that changed after it was locked. */
function enforce(mutations){
  for(var i=0;i<mutations.length;i++){
    var el = mutations[i].target;
    if(!el.classList || !el.classList.contains('sh')) continue;
    var want = el.getAttribute(LOCKED);
    if(!want) continue;
    var now = el.style.background || el.style.backgroundColor;
    if(now && now !== want){
      el.style.background = want;
    }
  }
}

function start(){
  var grid = document.getElementById('famGrid') ||
             document.querySelector('.grid, .rail');
  if(!grid) return;

  lockAll(grid);

  var obs = new MutationObserver(function(muts){
    /* Disconnect while correcting, or our own writes re-trigger this. */
    obs.disconnect();
    enforce(muts);
    /* New cards can arrive from filtering; give them their colour now. */
    lockAll(grid);
    obs.observe(grid, opts);
  });
  var opts = { subtree:true, childList:true, attributes:true, attributeFilter:['style'] };
  obs.observe(grid, opts);
}

/* Late enough that the first shuffle has already run and the colours on
   screen are the ones worth keeping. */
if(document.readyState === 'complete') setTimeout(start, 400);
else window.addEventListener('load', function(){ setTimeout(start, 400); });
})();